/**
 * @generated SignedSource<<d46651fd86bed8fd912a70648fa9e203>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenamePerspectiveInputObject = {
  name: string;
  perspectiveId: string;
};
export type categorizePage_RenamePerspectiveMutation$variables = {
  input: RenamePerspectiveInputObject;
};
export type categorizePage_RenamePerspectiveMutation$data = {
  readonly renamePerspective: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly perspective: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type categorizePage_RenamePerspectiveMutation = {
  response: categorizePage_RenamePerspectiveMutation$data;
  variables: categorizePage_RenamePerspectiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Perspective",
  "kind": "LinkedField",
  "name": "perspective",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "categorizePage_RenamePerspectiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RenamePerspectiveMutationPayload",
        "kind": "LinkedField",
        "name": "renamePerspective",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "categorizePage_RenamePerspectiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RenamePerspectiveMutationPayload",
        "kind": "LinkedField",
        "name": "renamePerspective",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ee8f598e619fd3b0be659a6b62abed46",
    "id": null,
    "metadata": {},
    "name": "categorizePage_RenamePerspectiveMutation",
    "operationKind": "mutation",
    "text": "mutation categorizePage_RenamePerspectiveMutation(\n  $input: RenamePerspectiveInputObject!\n) {\n  renamePerspective(input: $input) {\n    perspective {\n      id\n      name\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "31fa134f9cfa646fe29c8be469f75bfa";

export default node;
